import styled from 'styled-components';

export const ViewCampaignListContainer = styled.div`
    display: grid;
    grid-template-columns: ${({ $contentWidth }) =>
        `repeat(${$contentWidth > 625 ? 2 : 1}, 1fr)`};
    gap: 16px;
    width: 100%;
`;
